import React from 'react';
import BannerSingleImage from './BannerSingleImage';
import BannerSlider from './BannerSlider';
import BannerPromotions from './BannerPromotions';
import BannerOffers from './BannerOffers';
import BannerFeatured from './BannerFeatured';

const AllBanners = ({ banners }) => {

  const groupByOrderAndType = (banners) => {
    const allEntries = [];

    Object.entries(banners).forEach(([type, items]) => {
      items?.forEach((item) => {
        allEntries.push({ ...item, type, order: item.order ?? Infinity });
      });
    });

    allEntries.sort((a, b) => a.order - b.order);

    const usedOrders = new Set(allEntries.filter(item => item.order !== Infinity).map(item => item.order));

    const groups = [];
    let currentGroup = [];

    allEntries.forEach((curr, i) => {
      const prev = allEntries[i - 1];

      const hasOrderGap = prev && (curr.order !== Infinity && prev.order !== Infinity)
        ? [...Array(curr.order - prev.order - 1).keys()]
            .map(n => n + prev.order + 1)
            .some(o => usedOrders.has(o))
        : false;

      if (
        !prev ||
        hasOrderGap ||
        curr.type !== prev.type ||
        curr.group !== prev.group
      ) {
        if (currentGroup.length) groups.push(currentGroup);
        currentGroup = [curr];
      } else {
        currentGroup.push(curr);
      }
    });

    if (currentGroup.length) groups.push(currentGroup);

    return groups;
  };

  const groupedBanners = groupByOrderAndType(banners);

  return (
    <>
      {groupedBanners.map((group, i) => {
        const type = group[0].type;
        const title = group[0].group ?? '';
        const props = { key: i, banners: group, title };

        switch (type) {
          case 'Slider': return <BannerSlider {...props} />;
          case 'ImageCards':
          case 'TextImageCards': return <BannerPromotions {...props} />;
          case 'ProductCards': return <BannerOffers {...props} />;
          case 'HorizontalCardSlider': return <BannerFeatured {...props} />;
          case 'FullWidth': return <BannerSingleImage {...props} />;
          default: return null;
        }
      })}
    </>
  );
};

export default AllBanners;
